import './style.css';
import { register, start } from './router.js';
import { openAccountMenu, rerenderRoute } from './components/account-menu.js';
import { setViewing, activeUser, applyTheme } from './lib/auth.js';
import { renderLogin } from './screens/login.js';
import { renderDay } from './screens/day.js';
import { renderLogger } from './screens/logger.js';
import { renderHistory } from './screens/history.js';
import { renderRunning } from './screens/running.js';
import { renderProgress } from './screens/progress.js';
import { renderSettings } from './screens/settings.js';
import { renderProgramEditor } from './screens/program-editor.js';
import { renderFood } from './screens/food.js';
import { renderWeight } from './screens/weight.js';
import { initPullToRefresh } from './lib/pull-refresh.js';
import { ensureNames } from './lib/exercise-names.js';
import { initSheetDrag } from './components/sheet-drag.js';
import { pendingPill } from './components/header.js';
import { isPending } from './lib/db.js';

applyTheme(); // Cassidy's app is sage green

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .catch((err) => console.warn('SW registration failed', err));
  });
}

register('login', renderLogin);
register('home', renderDay);
register('logger', renderLogger);
register('running', renderRunning);
register('progress', renderProgress);
register('stats', renderHistory);
register('settings', renderSettings);
register('program-editor', renderProgramEditor);
register('food', renderFood);
register('weight', renderWeight);

// Header buttons live inside re-rendered innerHTML, so delegate at document level.
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-action="account-menu"]')) { openAccountMenu(); }
  if (e.target.closest('[data-action="back-to-self"]')) { setViewing(activeUser()); rerenderRoute(); }
});

if (activeUser()) ensureNames(activeUser()); // preload personal lift names for the first paint
start();
initPullToRefresh();
initSheetDrag();
// A hairline appears under the frosted top bar once content scrolls beneath it.
const onScroll = () => document.documentElement.classList.toggle('grit-scrolled', window.scrollY > 4);
window.addEventListener('scroll', onScroll, { passive: true });
// Keep the "waiting to send" pill and per-set clocks honest as the outbox drains.
window.addEventListener('grit-outbox', (e) => {
  const pill = document.getElementById('grit-pending');
  if (pill) pill.outerHTML = pendingPill(e.detail?.count ?? 0);
  document.querySelectorAll('[data-pend]').forEach((n) => { if (!isPending(n.dataset.pend)) n.remove(); });
});
window.addEventListener('hashchange', () => setTimeout(onScroll, 0));
